import { render, staticRenderFns } from "./FlowSwitchModule.vue?vue&type=template&id=51eaf57a&scoped=true&"
import script from "./FlowSwitchModule.vue?vue&type=script&lang=js&"
export * from "./FlowSwitchModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eaf57a",
  null
  
)

export default component.exports